import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { getCommissionsUseCase } from '../../di/usecase_module';
import { GetCommissionsRequestDto } from '../../domain/usecases/balance/GetCommissionsUseCase';
import { Commission } from '../../domain/models/Commission';
import { CommissionComponent } from './CommissionComponent';
import { groupBy } from '../../common/jsUtils/groupBy';
import { RowTitleSection } from './RowTitleSection';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { applog } from '../../domain/utils/applog';
import { ButtonDownloadExcelComponent } from '../csv/ButtonDownloadExcelComponent';
import { comissionToCsv } from './comissionToCsv';
import { CommissionRow } from './CommissionRow';

export const ModalCommissions = () => {

    const state = useSelector((state: RootState) => state.uiState);
    const dispatch = useDispatch();
    function handleHide() {
        dispatch(UIActions.closeCommissions());
    }
    const [commissions, setCommissions] = useState<CommissionRow[]>([]);
    function orderComs(coms: Commission[]) {
        const rows = new Array<CommissionRow>();
        const grouped = groupBy<Commission>(coms,
            (current: Commission) => current.group,
            (current: Commission, key: string) => current.group === key);


        const keys = Array.from(grouped.keys());
        keys.forEach((k) => {
            rows.push(new CommissionRow({ title: k }))
            const value = grouped.get(k) ?? [];
            value.forEach((com) => {
                rows.push(new CommissionRow({ commission: com }));
            })
        });
        setCommissions(rows);
    }



    useEffect(() => {
        if (state.isCommissionsOpen) {
            getCommissionsUseCase()
                .execute(new GetCommissionsRequestDto())
                .then((result) => {
                    orderComs(result);
                }).catch((e) => {
                    applog("COMMISSIONS ERROR", e);
                })
        }
    }, [state.isCommissionsOpen]);

    return (
        <Modal
            onHide={handleHide}
            show={state.isCommissionsOpen}
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton className='gradientBlue colorWhite'>
                <Modal.Title id="contained-modal-title-vcenter">
                    Comisiones
                </Modal.Title>
            </Modal.Header>
            <Modal.Body
                className='p-0'>
                <div className='d-flex flex-column'>

                    {
                        commissions.map((row) => {
                            if (row.title) {
                                return <RowTitleSection title={row.title} />
                            } else if (row.commission) {
                                return <CommissionComponent commission={row.commission} />
                            } else {
                                return (<></>)
                            }
                        })
                    }
                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className='align-self-end m-4'>
                    <ButtonDownloadExcelComponent 
                    className='btn btn-accent colorWhite bgAccent'
                    csvData={comissionToCsv(commissions)} fileName='Comisiones.csv' />
                </div>
                <button onClick={handleHide} className="btn btn-primary float-right">Cerrar</button>
            </Modal.Footer>
        </Modal>
    )
}
